import { render, staticRenderFns } from "./NoticePopup.vue?vue&type=template&id=9df48e50&scoped=true&"
import script from "./NoticePopup.vue?vue&type=script&lang=js&"
export * from "./NoticePopup.vue?vue&type=script&lang=js&"
import style0 from "./NoticePopup.vue?vue&type=style&index=0&id=9df48e50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df48e50",
  null
  
)

export default component.exports